import { createSelector } from 'reselect';
import { ApplicationState } from '../types';
const STUDENT_ID_REGEX = /^[a-zA-Z0-9]+$/;

const getStudentDetail = ({ studentDetail }: ApplicationState) => studentDetail;

export const getStudentDetails = createSelector(
  [getStudentDetail],
  (studentDetail) => studentDetail
);

export const hasStudentID = (studentDetail) => {
  return (
    studentDetail?.student &&
    studentDetail?.student?.firstName &&
    studentDetail?.student?.id.length > 0 &&
    STUDENT_ID_REGEX.test(studentDetail?.student?.id)
  );
};
